import CompletingBalanceSheetOfModuleSecond from "./CompletingBalanceSheetOfModuleSecond";
import { useState, useContext, useEffect } from "react";
import UserContext from "../../Contexts/UserContext";
import { ClientService } from "../../Services";

  function CompletingBalanceSheetOfModuleSecondv2() {
    const { user, setUser } = useContext(UserContext);
    const [vouchersAmount, setVouchersAmount] = useState();


    useEffect(()=>{
        ClientService.getClientVouchersAmount(user.id)
            .then((response) => {
            setVouchersAmount(response.data.avaliable_vouchers);
            })
            .catch((error) => {
              console.error(error);
            });
    },[])

    return (
      <>
       <CompletingBalanceSheetOfModuleSecond surveyType={4} voucherAmount={vouchersAmount}/>
      </>
    );
  }
  
  export default CompletingBalanceSheetOfModuleSecondv2;
  